import { apiClient } from '@/shared/services/client'
import type {
  Plantilla,
  PlantillaTwilio,
  Envio,
  EnvioFormData,
  AnalyticsDetallado,
  EstadisticasGenerales,
  ExcelProcessResult
} from '../types'

export const whatsappApi = {
  // Plantillas
  async getPlantillas(activas?: boolean): Promise<Plantilla[]> {
    const params = activas ? { activas: true } : {}
    const response = await apiClient.get('/whatsapp/plantillas/', { params })
    return response.data
  },

  async getPlantilla(id: number): Promise<Plantilla> {
    const response = await apiClient.get(`/whatsapp/plantillas/${id}`)
    return response.data
  },

  async getPlantillasTwilio(): Promise<PlantillaTwilio[]> {
    const response = await apiClient.get('/whatsapp/plantillas/twilio/disponibles')
    return response.data || []
  },

  async importarPlantilla(contentSid: string): Promise<Plantilla> {
    const response = await apiClient.post('/whatsapp/plantillas/importar', {
      content_sid: contentSid
    })
    return response.data
  },

  async eliminarPlantilla(id: number): Promise<void> {
    await apiClient.delete(`/whatsapp/plantillas/${id}`)
  },

  // Envíos
  async enviarMensajes(data: EnvioFormData): Promise<{ envio_id: number; mensaje: string }> {
    const response = await apiClient.post('/whatsapp/envios/enviar/', data)
    return response.data
  },

  async getEnvios(params?: {
    page?: number
    page_size?: number
    search?: string
    estado?: string
  }): Promise<{
    results: Envio[]
    count: number
    total_pages: number
  }> {
    const response = await apiClient.get('/whatsapp/envios/', { params })
    return response.data
  },

  async getEnvio(id: number): Promise<Envio> {
    const response = await apiClient.get(`/whatsapp/envios/${id}`)
    return response.data
  },

  // Analytics
  async getAnalyticsDetallado(envioId: number): Promise<AnalyticsDetallado> {
    const response = await apiClient.get(`/whatsapp/analytics/envio/${envioId}`)
    return response.data
  },

  async getEstadisticasGenerales(): Promise<EstadisticasGenerales> {
    const response = await apiClient.get('/whatsapp/analytics/generales')
    return response.data
  },

  async sincronizarEstado(envioId: number): Promise<{
    success: boolean
    mensaje: string
    logs_actualizados: number
  }> {
    const response = await apiClient.post(`/whatsapp/analytics/envio/${envioId}/sincronizar`)
    return response.data
  },

  async exportarExcel(envioId: number, numeros: string[]): Promise<Blob> {
    const response = await apiClient.post(
      `/whatsapp/analytics/envio/${envioId}/exportar-excel`,
      { numeros },
      { responseType: 'blob' }
    )
    return response.data
  },

  async procesarExcel(file: File, plantillaId?: number): Promise<ExcelProcessResult> {
    const formData = new FormData()
    formData.append('excel_file', file)
    if (plantillaId) {
      formData.append('plantilla_id', plantillaId.toString())
    }
    // Clear Content-Type header so axios sets multipart/form-data with correct boundary
    const response = await apiClient.post('/whatsapp/envios/procesar-excel/', formData, {
      headers: {
        'Content-Type': undefined
      }
    })
    return response.data.data
  }
}
